import { render, staticRenderFns } from "./IntegrationsPage.vue?vue&type=template&id=d8a48030&scoped=true&"
import script from "./IntegrationsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./IntegrationsPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./IntegrationsPage.vue?vue&type=style&index=0&id=d8a48030&prod&lang=scss&"
import style1 from "./IntegrationsPage.vue?vue&type=style&index=1&id=d8a48030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a48030",
  null
  
)

export default component.exports